import React from 'react';

import HotelCarousel from './HotelCarousel';
import ActivityCarousel from './ActivityCarousel';
import DiningCarousel from './DiningCarousel';

const Carousel = props => {
    const { data } = props;

    if(data.sort === 'accommodation') {
        return (
            <HotelCarousel 
                data={data}
            />
        )
    } else if(data.sort === 'adventures') {
        return (
            <ActivityCarousel 
                data={data}
            />
        )
    } else return (
        <DiningCarousel 
            data={data}
        />
    )
}

export default Carousel;